import type {
  CommonErrorEventMap,
  CommonInfoEventMap,
  CommonWarnEventMap,
} from "@peerup/browser-logger"
/**
 * @fileoverview accounts 应用日志枚举与事件映射
 *
 * 迁移自原 logger/types.ts。本文件作为 @peerup/browser-logger 的 app 侧扩展：
 * - 公共枚举（Common*Action）从包导入，与 accounts 私有枚举合并为同名导出
 * - 业务代码继续用 `ErrorAction.XXX` / `WarnAction.XXX` / `InfoAction.XXX`，无感知
 *
 * @mark accounts 的 perf 相关枚举（PERFORMANCE_METRIC）按私有保留；
 *       accounts 不启用 perf 插件（无 perf 目录）。
 */

import {
  CommonErrorAction,
  CommonInfoAction,
  CommonWarnAction,
} from "@peerup/browser-logger"

/**
 * 业务日志事件映射
 */
export interface LogEventMap {
  load_error: {
    url: string
  }
}
export type LogAction = keyof LogEventMap

// =====================================================================
// Warn
// =====================================================================

/** 合并导出：公共 + accounts 私有 */
export const WarnAction = { ...CommonWarnAction }
/** 合并 EventMap */
export type WarnEventMap = CommonWarnEventMap

// =====================================================================
// Error
// =====================================================================

/** 合并导出：公共 + accounts 私有 */
export const ErrorAction = { ...CommonErrorAction }
/** 合并 EventMap */
export type ErrorEventMap = CommonErrorEventMap

// =====================================================================
// Info
// =====================================================================
/** 合并导出：公共 + accounts 私有 */
export const InfoAction = { ...CommonInfoAction }
/** 合并 EventMap */
export type InfoEventMap = CommonInfoEventMap
